// Consts
export const ON_ORGANIZATION_CHANGE = 'ON_ORGANIZATION_CHANGE';

// Actions
export const onOrganizationChange = (ownerId, currencies, imageUrl, firstName, lastName) => {
  return {
    type: ON_ORGANIZATION_CHANGE,
    payload: { ownerId, currencies, imageUrl, firstName, lastName }
  };
};



// WEBPACK FOOTER //
// ./src/modules/organization-select/actions.js